<template>
  <div>
    <div class="panel-topnav">
      <ul class="nav nav-tabs">
        <li>
          <h3 class="page-title">
            Dashboard
          </h3>
        </li>
      </ul>
      <div class="clearfix" />
    </div>

    <div
      class="panel-card container-fluid"
      :class="{ 'loader-cover': fetchInProgress }"
    >
      <el-row class="flex-row" :gutter="20">
        <el-col :sm="24" :md="6" class="flex-col">
          <div class="organization-avatar top-pane panel-card-content">
            <h5>{{ organization.name }}</h5>
            <div class="pane-body">
              <img
                v-if="organization.logo_url"
                class="logo img-responsive"
                :src="organization.logo_url"
              />

              <div class="text-center">
                <router-link
                  class="text-center"
                  :to="{ name: 'dashboardMyOrganization' }"
                >
                  <el-button class="edit-profile-btn" type="primary" plain>
                    Edit profile
                  </el-button>
                </router-link>
              </div>
            </div>
          </div>
        </el-col>

        <el-col :sm="24" :md="18">
          <div class="panel-card-content top-pane">
            <OrganizationDashboardPrograms :organization="organization" />
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import notifications from 'services/notifications'
import _ from 'lodash'
import organizations from 'services/organizations'
import OrganizationDashboardPrograms from '@/modules/organizations/OrganizationDashboardPrograms'

export default {
  components: { OrganizationDashboardPrograms },
  data: () => {
    return {
      realOrgId: '',
    }
  },
  async created() {
    let orgId
    if (this.$route.name === 'adminOrganizationEdit') {
      const id = this.$route.params.organizationId
      this.$store.dispatch('organizationDetails/fetch', { id })
      orgId = id
    } else {
      const user = await this.$store.dispatch('user/getUser')
      this.$store.dispatch('organizationDetails/fetch', {
        id: user.organizationId,
      })
      orgId = user.organizationId
    }
    this.realOrgId = (await organizations.idToName(orgId)) || orgId
  },
  computed: {
    name: {
      get() {
        return this.$store.state.organizationDetails.organization.name
      },
      set: _.debounce(function (value) {
        this.$store.commit('organizationDetails/UPDATE_NAME', { name: value })
      }, 250),
    },
    logoUrl: {
      get() {
        return this.$store.state.organizationDetails.organization.logo_url
      },
      set(value) {
        this.$store.commit('organizationDetails/UPDATE_LOGO_URL', {
          logo_url: value,
        })
      },
    },
    isPublic: {
      get() {
        return this.$store.state.organizationDetails.organization.is_public
      },
      set(value) {
        this.$store.commit('organizationDetails/UPDATE_IS_PUBLIC', {
          is_public: value,
        })
      },
    },
    ...mapState({
      user: (state) => state.user.data,
      original: (state) => state.organizationDetails.original,
      organization: (state) => state.organizationDetails.organization,
      organizationFetched: (state) => state.organizationDetails.fetched,
      owners: (state) => state.adminOwnerList.owners,
      fetchInProgress: (state) => state.organizationDetails.fetchInProgress,
      organizationRoute(state) {
        const orgId = this.realOrgId
        return { name: 'organizationPage', params: { orgId } }
      },
    }),
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.top-pane {
  min-height: 31vh;

  .pane-body {
    padding-top: 30px;
  }
}

.organization-avatar {
  padding-bottom: 20px;
  min-width: 180px;

  .edit-profile-btn {
    margin: 20px auto 20px;
  }
}
.logo {
  margin: 30px auto 30px auto;
  max-width: 75%;

  @media screen and (min-width: theme('screens.md')) {
    max-width: 180px;
  }
}
</style>
